import React from "react";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";
import ApiAttribute from "components/ApiAttribute/ApiAttribute";

export function TabPanelQuery(props) {
  const { name, friendlyName, value, queryParams, sampleRequest } = props;
  return (
    <TabPanel value={value} index={2}>
      <div style={{ width: "66%" }}>
        <h3>Query</h3>
        <p>Returns a list of {friendlyName.toLowerCase()} objects.</p>
        <CodeCard>GET /api/v2/{name.toLowerCase()}</CodeCard>
        <h3>Result structure</h3>
        <ApiAttribute
          name={"count"}
          description={"The number of results returned in this query."}
        />
        <ApiAttribute
          name={"totalCount"}
          description={
            "The total number of records that match the filters of this query."
          }
        />
        <ApiAttribute
          name={"data"}
          description={`An array of ${friendlyName.toLowerCase()} objects.`}
        />
        <ApiAttribute
          name={"status"}
          description={
            "The status of the query.  Will be “ok” if successful, otherwise this matches with the message field to indicate why the call failed."
          }
        />
        <ApiAttribute
          name={"message"}
          description={
            "A descriptive message indicating why the query was unsuccessful."
          }
        />
        <h3>Arguments</h3>
        <p>
          Query parameters can be used as follows. All parameters are optional.
        </p>
        <CodeCard>GET {sampleRequest}</CodeCard>

        {queryParams.map(attribute => (
          <ApiAttribute
            key={attribute.name}
            name={attribute.name}
            type={attribute.type}
            description={attribute.description}
          />
        ))}
      </div>
    </TabPanel>
  );
}
